import i18n from 'i18next';

import Backend from 'i18next-xhr-backend';

import { initReactI18next } from 'react-i18next';

i18n
  .use(Backend)
  //   .use(LanguageDetector) // passes i18n down to react-i18next

  .use(initReactI18next)
  .init({
    lng: 'ko',
    fallbackLng: 'ko', // detected lng이 불가능 할때 en을 사용하겠다.

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
